"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlbumShareUrl = exports.getTrackShareUrl = void 0;
var url_1 = require("../utils/url/url");
var facebook_social_sharing_1 = require("./facebook-social-sharing");
var social_sharing_types_1 = require("./social-sharing-types");
var social_urls_builder_creator_1 = require("./social-urls-builder-creator");
function getShareUrl(social, settings, album, shareItem) {
    var urlsBuilder = (0, social_urls_builder_creator_1.socialUrlsBuilderCreator)(album, settings);
    return urlsBuilder[social](shareItem);
}
function tryGetFacebookShare(settings, social, album, track) {
    if (social === social_sharing_types_1.SOCIAL_SHARING_SERVICES.FACEBOOK) {
        return (0, facebook_social_sharing_1.getFacebookShareUrl)(settings, album, track);
    }
}
var getTrackShareUrl = function (settings, social, album, track) {
    var siteUrl = settings.siteUrl;
    var _a = siteUrl.split('?'), host = _a[0], queryParamsStr = _a[1];
    var queryParams = (0, url_1.parseParams)(queryParamsStr);
    var trackArgs = __assign(__assign({}, queryParams), { 'wix-music-track-id': track.id });
    if (settings.compId) {
        trackArgs['wix-music-comp-id'] = settings.compId;
    }
    var trackQueryString = (0, url_1.createParam)(trackArgs);
    var trackSiteUrl = "".concat(host, "?").concat(trackQueryString);
    var trackSettings = __assign(__assign({}, settings), { siteUrl: trackSiteUrl });
    return tryGetFacebookShare(trackSettings, social, album, track) || getShareUrl(social, trackSettings, album, track);
};
exports.getTrackShareUrl = getTrackShareUrl;
var getAlbumShareUrl = function (settings, social, album) {
    return tryGetFacebookShare(settings, social, album) || getShareUrl(social, settings, album, album);
};
exports.getAlbumShareUrl = getAlbumShareUrl;
//# sourceMappingURL=social-sharing.js.map